import { FC, MouseEvent, useCallback } from 'react';

import _ from '../../../locale';
import { AiChatDataCollectionOption } from '../../../types';
import Badge from '../../Badge';
import TruncatedTextWithTooltip from '../../TruncatedTextWithTooltip';
import { Chevron, OptionButton, OptionList, OptionRow, optionNameWrapperStyles } from './styles';

export interface DataCollectionOptionsProps {
    options: AiChatDataCollectionOption[];
    bestMatchId?: number | null;
    disabled?: boolean;
    onPick?: (dataCollectionId: number) => void;
}

const DataCollectionOptions: FC<DataCollectionOptionsProps> = ({
    options,
    bestMatchId,
    disabled = false,
    onPick,
}) => {
    const handleClick = useCallback(
        (event: MouseEvent<HTMLButtonElement>) => onPick?.(Number(event.currentTarget.value)),
        [onPick]
    );

    return (
        <OptionList role="group" aria-label={_('dex_chat_data_collection_options_label')}>
            {options.map((option) => {
                const label = (
                    <>
                        <TruncatedTextWithTooltip
                            text={option.name}
                            wrapperStyles={optionNameWrapperStyles}
                        />
                        {option.id === bestMatchId && (
                            <Badge>{_('dex_chat_data_collection_best_match')}</Badge>
                        )}
                    </>
                );

                return onPick ? (
                    <OptionButton
                        key={option.id}
                        type="button"
                        value={option.id}
                        disabled={disabled}
                        onClick={handleClick}
                    >
                        {label}
                        <Chevron src="/icons/ic-arrow.svg" width={6} height={10} />
                    </OptionButton>
                ) : (
                    <OptionRow key={option.id}>{label}</OptionRow>
                );
            })}
        </OptionList>
    );
};

export default DataCollectionOptions;
